module.exports = __webpack_public_path__ + "static/media/kristina.ea5538cc.jpg";